import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription, zip } from 'rxjs';
import { Master } from 'src/model/master';
import { Teklif } from 'src/model/teklif';
import { TeklifGirRequest } from 'src/model/teklif-gir-request';
import { TeklifGorsel } from 'src/model/teklif-gorsel';
import { TeklifKalem } from 'src/model/teklif-kalem';
import { TeklifKalemGirRequest } from 'src/model/teklif-kalem-gir-request';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-teklif-isteme-formu',
  templateUrl: './teklif-isteme-formu.component.html',
  styleUrls: ['./teklif-isteme-formu.component.css']
})
export class TeklifIstemeFormuComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];

  teklif: Teklif = new Teklif();
  kalemler: TeklifKalem[] = null;
  totalTutarText = '0';
  // tutarText = '0';
  talepTarihi = null;
  talepNo = null;

  paraBirimleri: Master[] = null;
  odemeYontemleri: Master[] = null;
  teslimYerleri: Master[] = null;
  teslimSekilleri: Master[] = null;

  publicAccessKey = null;

  constructor(private restService: RestService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params.key) {
        this.publicAccessKey = params.key;
        this.getTeklif(params.key);
      }
    }));

    const types = [
      Master.ParaBirimi,
      Master.OdemeYontemi,
      Master.TeslimYeri,
      Master.TeslimSekli
    ];
    this.restService.getMasterTypes(types).subscribe(res => {
      if (res) {
        this.paraBirimleri = res.ParaBirimi?.map(x => new Master(x));
        this.odemeYontemleri = res.OdemeYontemi?.map(x => new Master(x));
        this.teslimYerleri = res.TeslimYeri?.map(x => new Master(x));
        this.teslimSekilleri = res.TeslimSekli?.map(x => new Master(x));
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTeklif(publicAccessKey: string) {
    this.restService.teklifByAccessKey(publicAccessKey).subscribe(res => {
      if (res) {
        this.teklif = res;
        this.talepTarihi = this.teklif.talep?.olusturmaTarihiText;
        this.talepNo = this.teklif.talep?.talepNo;
        // this.router.navigate(['teklif-olusturuldu-public']);

        if (this.teklif?.durum === 0) {
          if (this.teklif.talep != null && this.teklif.talep.talepKalemler != null) {
            this.kalemler = [];
            for (const talepKalem of this.teklif.talep.talepKalemler) {
              const teklifKalem = new TeklifKalem();

              teklifKalem.talepKalemId = talepKalem.id;
              teklifKalem.tutar = null;
              teklifKalem.paraBirimiId = null;
              teklifKalem.talepKalem = talepKalem;
              this.kalemler.push(teklifKalem);
            }
          }
        }
        else {
          this.kalemler = this.teklif.teklifKalemler;
          this.toplamTutarHesapla();
        }
      }
    });
  }

  toplamTutarHesapla() {
    const array: ParaBirimiTutar[] = [];
    if (this.paraBirimleri) {
      for (const pb of this.paraBirimleri) {
        array.push(new ParaBirimiTutar(pb, 0));
      }
    }

    if (this.kalemler != null) {
      for (const t of this.kalemler) {
        const index = array.findIndex(x => x.paraBirimi.id === t.paraBirimiId);
        if (index !== -1) {
          array[index].tutar += t.tutar * t.talepKalem.talepEdilen;
        }
      }
    }

    const textArray = [];
    for (const e of array) {
      if (e.tutar !== 0) {
        textArray.push(`${e.tutar.toFixed(2)} ${e.paraBirimi.aciklama}`);
      }
    }
    this.totalTutarText = textArray.join(' + ');
  }

  teklifKaydet() {
    if (this.kalemler.findIndex(x => x.tutar === null || x.paraBirimiId === null) !== -1) {
      this.toastrService.info("Kalem Bilgilerini Eksiksiz Doldurunuz", "Uyarı!");
      return;
    }
    if (this.teklif.teslimSekliId === null || this.teklif.teslimSuresi === null) {
      this.toastrService.info("Teslim şekli ve teslim süresi girilmelidir!", "Uyarı");
      return;
    }

    const request = new TeklifGirRequest();
    request.teklifId = this.teklif.id;
    request.teslimYeriId = this.teklif.teslimYeriId;
    request.teslimSekliId = this.teklif.teslimSekliId;
    // request.odemeYontemiId = this.teklif.odemeYontemiId;
    // request.teslimTarihi = this.teklif.teslimTarihi;
    request.opsiyon = this.teklif.opsiyon;
    request.garantiSuresi = this.teklif.garantiSuresi;
    request.firmaTeklifNotu = this.teklif.firmaTeklifNotu;
    request.teslimSuresi = this.teklif.teslimSuresi;
    request.teklifGorseller = this.teklif.teklifGorseller;

    const kalemler: TeklifKalemGirRequest[] = [];
    if (this.kalemler != null) {
      for (const talepKalem of this.kalemler) {
        const kalem = new TeklifKalemGirRequest();
        kalem.teklifKalemId = talepKalem.id;
        kalem.talepKalemId = talepKalem.talepKalemId;
        kalem.birimFiyati = talepKalem.tutar;
        kalem.paraBirimiId = talepKalem.paraBirimiId;
        kalemler.push(kalem);
      }
    }
    request.kalemler = kalemler;
    request.publicAccessKey = this.publicAccessKey;
    this.restService.teklifKaydet(request).subscribe(res => {
      this.router.navigate(['teklif-olusturuldu-public']);
    });
  }

  downloadFile(fileName: string) {
    this.restService.downloadFile(fileName).subscribe(res => {
    });
  }

  removeGorsel(index: number) {
    this.teklif.teklifGorseller.splice(index, 1);
  }

  onFileChanged(event): void {
    const file = event.target.files[0];
    this.restService.uploadFile(file).subscribe(res => {
      if (res != null && res.file != null) {
        const gorsel = new TeklifGorsel();
        gorsel.dosya = res.file;
        this.teklif.teklifGorseller.push(gorsel);
      }
    });
  }
}

export class ParaBirimiTutar {
  paraBirimi: Master;
  tutar: number;

  constructor(paraBirimi: Master, tutar: number) {
    this.paraBirimi = paraBirimi;
    this.tutar = tutar;
  }
}
